import { render, staticRenderFns } from "./ModalHomeCategory.vue?vue&type=template&id=6fd831c6"
import script from "./ModalHomeCategory.vue?vue&type=script&lang=js"
export * from "./ModalHomeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports